import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {LanguagesListHeader} from './components/header/LanguagesListHeader'
import {LanguagesTable} from './table/LanguagesTable'
import {LanguageEditModal} from './language-edit-modal/LanguageEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const LanguagesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <LanguagesListHeader />
        <LanguagesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <LanguageEditModal />}
    </>
  )
}

const LanguagesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <LanguagesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {LanguagesListWrapper}
